import { useState, useEffect, useCallback } from 'react';
import useStore from '../../../../store';
import { useTranslation } from 'react-i18next';

export function useWordleLogic(socket, options = {}) {
  const { t } = useTranslation();
  const storeState = useStore.getState();
  const userId = String(storeState.ref.telegram.telegramUserId);

  const [state, setState] = useState({
    wordLength: 5,
    history: [],
    attempts: 0,
    maxAttempts: 6,
    completed: false,
    won: false
  });

  const [typedWord, setTypedWord] = useState('');
  const [showResults, setShowResults] = useState(false);
  const [finalData, setFinalData] = useState(null);
  const [shakeRow, setShakeRow] = useState(false);
  const [errorStamp, setErrorStamp] = useState(null);

  const sendAction = useCallback((actionType, payload = {}) => {
    const currentStore = useStore.getState();
    currentStore.ref.work.methods.hostAction('mafiaMiniGameAction', {
      type: actionType,
      userId: userId,
      ...payload
    });
  }, [userId]);

  const triggerError = useCallback((reasonKey) => {
    setShakeRow(true);
    setErrorStamp(t(`arcade.wordle_err_${reasonKey}`));
    window.croco?.haptic?.('error');
    setTypedWord(''); // Стираем слово при ошибке
    setTimeout(() => {
      setShakeRow(false);
      setErrorStamp(null);
    }, 1200);
  }, [t]);

  useEffect(() => {
    if (!socket) return;
    sendAction('init');

    const handleEvent = (data) => {
      if (data.type === 'update' || data.type === 'success') {
        if (data.state) setState(data.state);
        if (data.type === 'success') {
          setTypedWord(''); // Очищаем строку после успешного сабмита
          window.croco?.haptic?.('success');
        }
      } else if (data.type === 'reject') {
        triggerError(data.reason);
      } else if (data.type === 'finish' || data.type === 'game_over') {
        if (data.state) setState(data.state);
        setTypedWord(''); // <-- АРХИТЕКТУРНОЕ ИСПРАВЛЕНИЕ: Очищаем локальный буфер ввода при завершении игры
        setFinalData(data.finalData || data);
        setShowResults(true);
        window.croco?.haptic?.(data.result === 'win' ? 'success' : 'warning');
      }
    };

    socket.on('arcade:event', handleEvent);
    return () => socket.off('arcade:event', handleEvent);
  }, [socket, sendAction, triggerError]);

  return {
    state,
    typedWord,
    setTypedWord,
    showResults,
    setShowResults,
    finalData,
    sendAction,
    shakeRow,
    errorStamp
  };
}